import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { CopyButton, Text } from '@reveni-io/reveni-ui'

import { providers } from '@/returns/constants'

import * as Styles from './styles'

const CodeWidget = ({ store, divInfo, scriptInfo }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Styles.CodeContainer>
      <Text type="titleS">{t('Código')}</Text>
      <Text type="bodyMRegular" customStyles={{ marginTop: theme.spacing.sp8 }}>
        {t(
          'Copia este código y añádelo justo antes de la etiqueta </html> de las páginas en que quieras mostrar el widget.'
        )}
      </Text>
      <Styles.Code>
        <Text type="bodyMonospaced" color={theme.colors.outline.default}>
          {scriptInfo}
        </Text>
        <CopyButton info={scriptInfo} />
      </Styles.Code>

      {divInfo && store?.provider !== providers.shopify && (
        <>
          <Text type="bodyMRegular" customStyles={{ marginTop: theme.spacing.sp16 }}>
            {t(
              'Copia este código y añádelo al HTML de la plantilla de tus páginas de producto, donde quieras que se muestre el widget.'
            )}
          </Text>
          <Styles.Code>
            <Text type="bodyMonospaced" color={theme.colors.outline.default}>
              {divInfo}
            </Text>
            <CopyButton info={divInfo} />
          </Styles.Code>
        </>
      )}
    </Styles.CodeContainer>
  )
}

export default CodeWidget
